module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGhlaWdodD0iNTEyIiB3aWR0aD0iNTEyIiB2aWV3Qm94PSIwIDAgNTEyIDUxMiI+CiAgPGcgZmlsbC1ydWxlPSJldmVub2RkIj4KICAgIDxwYXRoIGZpbGw9IiNmZmYiIGQ9Ik0wIDBoNTEydjUxMkgweiIvPgogICAgPHBhdGggZmlsbD0iIzAwMWI5YSIgZD0iTTAgMTczLjM4aDUxMnYxNzAuNjdIMHoiLz4KICAgIDxwYXRoIGZpbGw9IiNlNzAwMDAiIGQ9Ik0wIC4wNDVoNTEydjg4SDB6TTAgNDI2LjY3aDUxMnY4NS4zMzNIMHoiLz4KICA8L2c+Cjwvc3ZnPgo="


//////////////////
// WEBPACK FOOTER
// ./~/flag-icon-css/flags/1x1/th.svg
// module id = ./node_modules/flag-icon-css/flags/1x1/th.svg
// module chunks = 0